@if (items && items.length) {
  <div id="item-container" class="inline-scroll" (scrollChange)="updatePosition($event)">
    @for (item of items; track item; let i = $index) {
      <customizer-item
        (click)="setSelected(i)"
        [ngClass]="{'is-selected': i === selectedIndex}"
        [item]="item"
        [name]="name"
        [image]="image"
        [description]="description"
        [discontinued]="discontinued"
        [editMode]="editMode"
        [selected]="i === selectedIndex"
        [isModelSize]="isModelSize"
        [isGemstone]="isGemstone"
        [variantOrModelIsNew]="variantOrModelIsNew"
        [noneChoiceTranslation]="noneChoiceTranslation"
        [noneChoiceImage]="noneChoiceImage"
        >
      </customizer-item>
    }
  </div>
}